<template>
  <div class="docBody">
    <div class="slide" v-if="doc">
      <div class="top">
        <div class="name">
          QApiDocument
        </div>
      </div>
      <van-search
        v-model="searchApiString"
        placeholder="检索接口路径或名称"
        input-align="left"
        style="border-bottom: 1px solid #eee;border-top: 1px solid #eee;"
      />
      <div class="api-lists" id="apiListScroll">
        <div class="content" v-if="choseVersion" style="padding-top: 0">
          <div v-for="(m,mk) of doc[choseApp][choseHost].doc[choseVersion]" :key="mk">
            <div class="module" v-if="moduleSearch(m,mk)">
              <div class="name qname" @click="checkItem(mk)">{{ mk }}
                <van-icon style="margin-right: 20px"
                          :name="!isOpenItem[mk]?'arrow-down':'arrow-up'"
                />
              </div>
              <CollapseTransition>
                <ul class="module-lists" v-show="!isOpenItem[mk]">
                  <template v-for="(d,index) in m">
                    <li
                      :title="d.SystemPath"
                      :id="choseApp+'_'+choseHost+'_'+choseVersion+'_'+mk+'_'+index"
                      :key="index" @click="choseApi(mk,index)" :class="{
                curr:(parseInt(api)===parseInt(index) && mk === module)
              }"
                      v-if="d.summary.indexOf(searchApiString)>-1 || d.SystemPath.indexOf(searchApiString)>-1 || d.path.indexOf(searchApiString)>-1
                    || mk.indexOf(searchApiString)>-1 || d.description.indexOf(searchApiString)>-1"
                    >
                      <div class="d-name">{{ d.summary }}
                      </div>
                      <div class="d-desc">
                        {{ d.description }}
                      </div>
                      <div class="d-msg">
                        <div class="method">
                          <van-tag :type="apiType(d.type)" plain size="mini">{{
                              d.type
                            }}
                          </van-tag>
                        </div>
                        <div class="url">
                          <span style="font-size: 10px;color: #999;padding:0 5px 0 5px;">{{ d.SystemPath }}</span>
                        </div>
                      </div>
                    </li>
                  </template>
                </ul>
              </CollapseTransition>

            </div>
          </div>
        </div>
        <div v-else style="color: #444;">
          <van-empty description="未选择项目"/>
        </div>
        <div style="color: #444" v-if="searchEmpty(this.choseApp,this.choseHost,this.choseVersion,this.searchApiString)  &&
        (searchApiString && retrieval())">
          <van-empty description="无符合筛选条件的接口"/>
        </div>
      </div>
      <div class="appSelect" style="display: flex;justify-content: space-between;">
        <van-button size="small" :type="isClose?'danger':'primary'" @click="allClose" :title="!isClose?'全部展开':'全部关闭'">
          <van-icon :name="!isClose?'shrink':'expand'" style="color: #fff;"/>
        </van-button>
        <div style="width: 10px;"></div>
        <van-button size="small" type="primary" @click="show=true" style="flex: 1">切换项目接口</van-button>
        <div style="width: 10px;"></div>
        <van-button size="small" type="default" @click="jumpToMenuLocation" title="定位到菜单位置">
          <van-icon name="aim"/>
        </van-button>
      </div>
    </div>

    <div class="right-body"
         style="display: flex;flex-direction: column;flex:1;height: 100vh;padding-right: 65px;min-width:1000px;position: relative;padding-top: 10px;
    padding-left: 10px;">
      <!--      @edit="onEdit"-->
      <a-tabs v-model="tabActiveIndex" hide-add animated type="editable-card" @edit="editTab" @change="changeTab">
        <a-tab-pane :key="0" tab="API 目录" :closable="false">
          <div class="body" style="flex: 1;overflow-y: auto;overflow-x: auto">
            <div class="popup-lists" style="width: 100%;background: #fff" v-if="choseVersion">
              <h1 style="color: #444;padding-top: 20px;border-bottom: 1px solid #eee;padding-bottom: 30px;">API 目录</h1>
              <div class="module" v-for="(m,key) in doc[choseApp][choseHost].doc[choseVersion]" :key="key">
                <div class="module" v-if="m.length>0">
                  <div class="name">{{ key }}</div>
                  <ul class="module-lists">
                    <li v-for="(d,index) in m" :key="index" @click="choseApi(key,index)" :class="{
                curr:(api==index && key == module)
              }">
                      {{ d.summary }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane v-for="(tab) in tabs" :key="tab.type+'@'+tab.SystemPath" :closable="true">
          <span slot="tab">
                  <a-popover>
                    <template slot="title"><div class="d-name">{{ tab.summary }}</div></template>
                    <template slot="content">
                      <div class="d-desc">
                        {{ tab.description }}
                      </div>
                      <div class="d-msg">
                        <div class="method">
                          <van-tag :type="apiType(tab.type)" plain size="mini">{{
                              tab.type
                            }}
                          </van-tag>
                        </div>
                        <div class="url">
                          <span style="font-size: 10px;color: #999;padding:0 5px 0 5px;">{{ tab.SystemPath }}</span>
                        </div>
                      </div>
                      </template>
                    <van-tag :type="apiType(tab.type)" plain size="small">{{ tab.type }}
                    </van-tag>
                    {{ tab.summary }}
                </a-popover>
          </span>
          <div class="body" style="flex: 1;overflow-y: auto;overflow-x: auto">
            <div class="box">
              <!--          {{doc[choseApp][choseHost].doc[choseVersion]}}   21658646464+6-->
              <div class="title margin" style="padding-left: 15px;">
                {{ tab.summary }}
              </div>

              <div class="description" style="padding-left: 15px;">
                {{ tab.description }}
              </div>
              <div class="title margin" style="padding-left: 15px;">
                接口地址:
                <van-tag size="large">{{ tab.SystemPath }}</van-tag>
              </div>
              <div class="description" style="padding-left: 15px;">
                <van-tag :type="apiType(tab.type)" plain size="large">{{
                    tab.type
                  }}
                </van-tag>
                &nbsp; &nbsp;
                <span style="font-size: 16px;" :title="tab.SystemPath">{{
                    doc[choseApp][choseHost].scheme
                  }}://{{
                    doc[choseApp][choseHost].host
                  }}{{ tab.path }}</span>
              </div>
              <van-collapse v-model="activeNames" style="margin-top: 30px" :border="false">
                <van-collapse-item title-class="title" name="1" :border="false">
                  <template slot="title">

                    <div class="title">
                      接口请求
                    </div>
                  </template>
                  <div class="description">
                    <table class="apiTable" border="0" cellspacing="0" cellpadding="0">
                      <thead>
                      <tr>
                        <td>参数名</td>
                        <td>简介</td>
                        <td>参数位置</td>
                        <td>参数类型</td>
                        <td>必填</td>
                        <td>参数值</td>
                        <td style="width: 300px;">描述</td>
                      </tr>
                      </thead>
                      <tbody>
                      <template v-for="(params,k) in tab.params">
                        <template
                          v-if="k==='QApi\\Attribute\\Parameter\\HeaderParam' || k==='QApi\\Attribute\\Parameter\\PostParamFromTableField' || k==='QApi\\Attribute\\Parameter\\GetParamFromTableField' || k==='QApi\\Attribute\\Parameter\\PathParamFromTableField' || k==='QApi\\Attribute\\Parameter\\GetParam' || k==='QApi\\Attribute\\Parameter\\PathParam'||k==='QApi\\Attribute\\Parameter\\PostParam'">
                          <tr :key="choseApp+'##'+choseHost+'--'+choseVersion+'--'+module+'--'+k+'--'+getKey"
                              v-for="(data,getKey) in params">

                            <td>
                              {{ data.name }}
                            </td>
                            <td>
                              {{ data.summary || '无' }}
                            </td>
                            <td>
                              <van-tag v-if="k==='QApi\\Attribute\\Parameter\\HeaderParam'" size="large" type="primary"
                                       plain>
                                header
                              </van-tag>
                              <van-tag
                                v-else-if="k==='QApi\\Attribute\\Parameter\\PathParam'|| k==='QApi\\Attribute\\Parameter\\PathParamFromTableField'"
                                size="large"
                                type="danger"
                                plain>
                                path
                              </van-tag>
                              <van-tag
                                v-else-if="k==='QApi\\Attribute\\Parameter\\GetParam' || k==='QApi\\Attribute\\Parameter\\GetParamFromTableField'"
                                size="large"
                                type="success"
                                plain>
                                query
                              </van-tag>
                              <van-tag
                                v-else-if="k==='QApi\\Attribute\\Parameter\\PostParam' || k==='QApi\\Attribute\\Parameter\\PostParamFromTableField'"
                                size="large"
                                type="warning"
                                plain>
                                form-data
                              </van-tag>
                            </td>
                            <td>
                              <van-tag size="large" :type="typeColor(data.type)">
                                {{ data.type }}
                              </van-tag>
                            </td>
                            <td>
                              <van-tag :type="data.required!==true?'success':'warning'" size="large" round plain>
                                {{ data.required }}
                              </van-tag>
                            </td>
                            <td>
                              <form-file v-model="data.default" v-if="data.type==='file'" class="file" :class="{
                      // 'danger':data.required === true&&!data.default
                    }"/>
                              <textarea placeholder="参数值" v-model="data.default" :class="{
                      // 'danger':data.required === true&&!data.default
                    }" v-else/>
                            </td>
                            <td>
                              {{ data.description || '无' }}
                            </td>
                          </tr>
                        </template>
                      </template>
                      </tbody>
                    </table>
                  </div>
                  <div class="title margin">
                    <van-button size="small" style="padding: 0 30px;" type="primary"
                                @click="run(tab)">运行
                    </van-button>
                    <van-button @click="saveResponse(tab)" size="small"
                                style="padding: 0 30px;float: right" type="default"
                                v-if="tab.response">保存示例
                    </van-button>
                  </div>
                  <div class="description" style="margin-top: 20px;">
                    <vue-json-pretty :path="'res'" :data="tab.response"
                                     v-if="tab.response"
                                     @click="showKey"></vue-json-pretty>
                  </div>
                </van-collapse-item>
                <div style="display: flex;flex-direction: row">
                  <van-collapse-item title="返回示例" name="3" :border="false" style="flex: 1;overflow: auto">
                    <template slot="title">
                      <div class="title">
                        返回示例
                      </div>
                    </template>
                    <a-tabs v-if="tab.responses && !saveLoading" hide-add="" @edit="editResponseTag"
                            type="editable-card" style="flex: 1">
                      <a-tab-pane v-for="(res,tag) in tab.responses" :tab="tag"
                                  :key="tab.type+'@'+tab.SystemPath+'#---'+tag">
                        <vue-json-pretty :path="'res'" :data="res"
                                         v-if="tab.response"
                                         @click="showKey"></vue-json-pretty>
                      </a-tab-pane>
                    </a-tabs>
                  </van-collapse-item>
                  <van-collapse-item title="数据字典" name="2" :border="false" style="flex: 1">

                    <template slot="title">

                      <div class="title">
                        数据字典
                      </div>
                    </template>
                    <van-search
                      v-model="searchField"
                      placeholder="请输入需要检索的字段或标签"
                      input-align="center"
                      background="#07c160"
                      style="border: 1px solid #eee;border-bottom: 0;"
                    />
                    <div class="description">
                      <table class="apiTable" border="0" cellspacing="0" cellpadding="0" style="border-top: none;">
                        <thead>
                        <tr>
                          <td>字段标签</td>
                          <td>字段名</td>
                          <td>字段类型</td>
                          <td>字段说明</td>
                        </tr>
                        </thead>
                        <tbody>
                        <template
                          v-for="(d,k) in tab.resultDictionary">
                          <template v-for="(data,getKey) in d">
                            <tr :key="'doc_field-'+k+'-'+getKey"
                                v-show="k.indexOf(searchField)>-1 || data.name.indexOf(searchField)>-1">
                              <td>
                                <van-tag size="large" type="success">
                                  {{ k }}
                                </van-tag>
                              </td>
                              <td>
                                {{ data.name }}
                              </td>
                              <td>
                                <van-tag>{{ data.type || '无' }}</van-tag>
                              </td>
                              <td>
                                {{ data.comment }}
                              </td>
                            </tr>
                          </template>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </van-collapse-item>
                </div>

              </van-collapse>

            </div>
          </div>
        </a-tab-pane>
      </a-tabs>

      <van-icon name="replay" size="18"
                color="#222"
                style="position:absolute;cursor:pointer;right: 15px;top: 50px;background: #fff;width: 40px;height: 40px;border:1px solid #eee;box-shadow: 6px 6px 6px #aaa;border-radius: 40px;text-align: center;line-height: 40px;"
                @click="refreshApi" class="refreshApi" title="刷新接口文档"/>
      <van-icon name="revoke" size="18"
                color="#222"
                style="position:absolute;cursor:pointer;right: 15px;top: 110px;background: #fff;width: 40px;height: 40px;border:1px solid #eee;box-shadow: 6px 6px 6px #aaa;border-radius: 40px;text-align: center;line-height: 40px;"
                @click="logout" class="logout" title="退出登录"/>
    </div>

    <van-popup v-model="showSearch" position="right" style="width: 750px;min-height: 100%;" title="结构目录">
      <div class="popup-lists" style="height: 100%;" v-if="choseVersion">
        <div v-for="(m,key) in doc[choseApp][choseHost].doc[choseVersion]" :key="key">
          <div class="module" v-if="m.length>0">
            <div class="name">{{ key }}</div>
            <ul class="module-lists">
              <li v-for="(d,index) in m" :key="index" @click="choseApi(key,index)" :class="{
                curr:(api==index && key == module)
              }">
                {{ d.summary }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show" round position="center" style="width: 450px;">
      <van-cascader
        v-model="cascaderValue"
        title="请选择项目"
        active-color="#07c160"
        :options="options"
        @close="show = false"
        @finish="choseFinish"
      />
    </van-popup>
    <a-modal v-model="visibleSaveResponse" name="保存示例" okText="确定保存" cancelText="取消保存" :confirm-loading="saveLoading"
             @ok="saveResponseByTag" width="400px" title="保存示例">
      <div>
        标签名：
        <a-input placeholder="请输入标签名 如 SUCCESS FAIL" v-model="tag" style="width: 80%;"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import FormFile from "./FormFile";
import CollapseTransition from "../assets/transition";

export default {
  name: "doc",
  components: {FormFile, VueJsonPretty, CollapseTransition},
  data() {
    return {
      show: false,
      doc: [],
      tag: undefined,
      saveLoading: false,
      showSearch: false,
      keywords: '',
      tabActiveIndex: 0,
      activeKey: 0,
      tabs: [],
      choseApp: this.$route.query.app || null,
      choseHost: this.$route.query.host || null,
      choseVersion: this.$route.query.version || null,
      module: this.$route.query.m || null,
      api: this.$route.query.api || null,
      apiData: null,
      cascaderValue: '',
      searchApiString: '',
      options: [],
      searchField: '',
      activeNames: ['1', '2', '3'],
      isOpenItem: {},//折叠面板的数据
      titleArr: [],
      isClose: true,
      currentApi: undefined,
      visibleSaveResponse: false,
    };
  },
  created() {
    this.loadDoc();
  },
  methods: {
    changeTab(key) {
      if (!key) {
        this.choseApi(0, 0);
      } else {
        for (let i = 0; i < this.tabs.length; i++) {
          if (this.tabs[i].key === key) {
            this.choseApi(this.tabs[i].module, this.findApiIndex(this.tabs[i].module, this.tabs[i].type, this.tabs[i].SystemPath));
          }
        }
      }
    },
    findApiIndex(module, type, SystemPath) {
      for (let i = 0; i < this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][module].length; i++) {
        if (this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][module][i].SystemPath === SystemPath && this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][module][i].type === type) {
          return i;
        }
      }
    },
    editTab(key, action) {
      if (action === 'remove') {
        for (let i = 0; i < this.tabs.length; i++) {
          if (this.tabs[i].key === key) {
            this.tabs.splice(i, 1);
            if (i >= 1) {
              let tab = this.tabs[i - 1];
              this.tabActiveIndex = tab.key;
              this.choseApi(tab.module, this.findApiIndex(tab.module, tab.type, tab.SystemPath));
            } else {
              this.tabActiveIndex = 0;
              this.$router.push({
                path: '/',
                query: {
                  app: this.choseApp,
                  host: this.choseHost,
                  version: this.choseVersion,
                }
              });
            }
          }
        }
      }
    },
    jumpToMenuLocation() {
      let id = this.choseApp + '_' + this.choseHost + '_' + this.choseVersion + '_' + this.module + '_' + this.api;
      let menuDom = document.getElementById(id);
      document.getElementById('apiListScroll').scrollTop = menuDom.offsetTop - 139;
    },
    // 一级折叠
    checkItem(index) {
      this.$set(this.isOpenItem, index, !this.isOpenItem[index]);
    },
    showKey(path) {
      let dd = path.split('.');
      this.searchField = dd[dd.length - 1];
    },
    choseApi(m, api) {
      if (
        typeof this.doc[this.choseApp] == "undefined" ||
        typeof this.doc[this.choseApp][this.choseHost] == "undefined" ||
        typeof this.doc[this.choseApp][this.choseHost].doc[this.choseVersion] == "undefined" ||
        typeof this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][m] == "undefined" ||
        typeof this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][m][api] == "undefined"
      ) {
        let query = {};
        if (typeof this.doc[this.choseApp] != "undefined") {
          query.app = this.choseApp;
        }
        if (typeof this.doc[this.choseApp][this.choseHost] != "undefined") {
          query.host = this.choseHost;
        }
        if (typeof this.doc[this.choseApp][this.choseHost].doc[this.choseVersion] != "undefined") {
          query.version = this.choseVersion;
        }
        return this.$router.replace({
          path: '/',
          query: query
        });
      }
      window.localStorage.setItem('api', [m, api])
      if (this.module === m && parseInt(this.api) === api) {
        return;
      }
      let doc = this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][m][api];
      doc.module = m;
      doc.key = doc.type + '@' + doc.SystemPath;
      let has = false;
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].key === doc.key) {
          has = true;
          break;
        }
      }
      if (!has) {
        this.tabs.push(doc);
      } else {
        for (const tabsKey in this.tabs) {
          if (this.tabs[tabsKey].key === doc.key) {
            this.tabs[tabsKey] = doc;
          }
        }
      }
      this.currentApi = doc;
      this.tabActiveIndex = doc.key;
      this.$router.replace({
        path: '/',
        query: {
          app: this.choseApp,
          host: this.choseHost,
          version: this.choseVersion,
          m: m,
          api: api,
        }
      });
      this.showSearch = false;
    },
    typeColor(type) {
      if (type === 'string' || type.indexOf('text') > -1 || type.indexOf('char') > -1) {
        return 'primary';
      } else if (type === 'int' || type.indexOf('int') > -1 || type.indexOf('float') > -1 || type.indexOf('double') > -1 || type.indexOf('decimal') > -1) {
        return 'success';
      } else if (type === 'json' || type === 'array' || type === 'float') {
        return 'warning';
      } else if (type === 'file') {
        return 'danger';
      }
      return 'default';
    }
    ,
    apiType(type) {
      if (type === 'GET') {
        return 'success';
      } else if (type === 'POST') {
        return 'primary';
      } else if (type === 'PUT') {
        return 'warning';
      } else if (type === 'DELETE') {
        return 'danger';
      }
      return 'success';
    }
    ,
    logout() {
      this.$store.dispatch('logout').then(() => {
        location.href = './index.html#/';
        location.reload();
      });
    },
    editResponseTag(key, action) {
      if (action === 'remove') {
        let that = this;
        this.$confirm({
          title: '温馨提示',
          content: '您确定要删除此示例吗？',
          onOk() {
            that.$http.delete('__apiResponses.json', {
              path: that.choseApp + '##' + that.currentApi.path,
              type: that.currentApi.type,
              token: that.$store.state.password,
              tagName: key.substring((that.currentApi.type + '@' + that.currentApi.SystemPath + '#---').length),
            }, {}).then(res => {
              if (res.status) {
                that.$toast('删除成功！');
                that.loadResponse(that.currentApi, true);
              }
            })
          },
        })
      }
    },
    loadResponse(api, force = false) {
      if (!api.response || force) {
        this.$http.getJSON('__apiResponse.json', {
          path: this.choseApp + '##' + api.path,
          type: api.type,
          token: this.$store.state.password,
        }).then(res => {
          api.response = false;
          api.response = JSON.parse(res.data);
        });
      }
      if (!api.responses || force) {
        let index = this.activeNames.indexOf('3');
        if (index > -1) {
          this.activeNames.splice(index, 1);
        }
        this.$http.getJSON('__apiResponses.json', {
          path: this.choseApp + '##' + api.path,
          type: api.type,
          token: this.$store.state.password,
        }).then(res => {
          api.responses = false;
          let responses = {};
          for (const resKey in res.data) {
            responses[resKey] = JSON.parse(res.data[resKey]);
          }
          api.responses = responses;
          this.activeNames.push('3');
        });
      }
    }
    ,
    saveResponseByTag() {
      this.saveLoading = true;
      this.$http.post('__apiResponses.json', {
        path: this.choseApp + '##' + this.currentApi.path,
        type: this.currentApi.type,
        token: this.$store.state.password,
      }, {
        response: JSON.stringify(this.currentApi.response),
        tagName: this.tag,
      }).then(res => {
        if (res.status) {
          this.$toast('保存成功！');
          this.loadResponse(this.currentApi, true);
        }
      }).finally(() => {
        this.saveLoading = false;
        this.visibleSaveResponse = false;
      });
    },
    saveResponse(api) {
      this.currentApi = api;
      this.visibleSaveResponse = true;
      this.$http.post('__apiResponse.json', {
        path: this.choseApp + '##' + api.path,
        type: api.type,
        token: this.$store.state.password
      }, {
        response: JSON.stringify(api.response),
      });
    },
    run(api) {
      let load = this.$toast.loading('运行中');
      this.$http.request(api, this.doc[this.choseApp][this.choseHost].scheme + '://' + this.doc[this.choseApp][this.choseHost].host).then(res => {
        api.response = res.data;
      }).then(() => {
        return this.$notify({
          type: 'success',
          message: '接口运行成功!',
        });
      }).catch((err) => {
        if (typeof err.response.data == 'object') {
          api.response = err.response.data;
          return this.$notify({
            type: 'danger',
            message: err.response.data.msg,
          });
        } else {
          return this.$notify({
            type: 'danger',
            message: err.response.statusText,
          });
        }
      }).finally(() => {
        load.clear();
      });
    }
    ,
    choseFinish(d) {
      this.show = false;
      if (d.selectedOptions[0].value != this.choseApp) {
        this.tabs = [];
        this.tabActiveIndex = 0;
      }
      this.choseApp = d.selectedOptions[0].value;
      this.choseHost = d.selectedOptions[1].value;
      this.choseVersion = d.selectedOptions[2].value;
      let module = [this.choseApp, this.choseHost, this.choseVersion]
      window.localStorage.setItem('module', module)
      let storage1 = window.localStorage.getItem('api')
      if (storage1) {
        if (this.module != storage1.split(',')[0]) {
          this.$router.replace({
            path: '/',
            query: {
              app: this.choseApp,
              host: this.choseHost,
              version: this.choseVersion,
            }
          });
          window.localStorage.clear()
        } else {
          let m = storage1.split(',')[0]
          let api = storage1.split(',')[1]
          this.choseApi(m, api)
        }
      } else {
        this.$router.replace({
          path: '/',
          query: {
            app: this.choseApp,
            host: this.choseHost,
            version: this.choseVersion,
          }
        });
      }
    }
    ,
    refreshApi() {
      let toast = this.$toast.loading('正在刷新');
      this.$http.post('__apis.json', {token: this.$store.state.password}, {}).then(res => {
        if (!res.status) {
          return this.$notify({
            type: 'danger',
            message: res.msg,
          });
        }
        let options = [];
        this.doc = [];
        this.doc = res.data;
        for (let key in this.doc) {
          let hosts = [];
          for (let host in this.doc[key]) {
            let versions = [];
            for (let version in this.doc[key][host].doc) {
              versions.push({
                text: '版本-' + version,
                value: version,
              });
            }
            hosts.push({
              text: this.doc[key][host].host + ' - ' + this.doc[key][host].mode,
              value: host,
              children: versions,
            });
          }
          let app = {
            text: key,
            value: key,
            children: hosts,
          };
          options.push(app);
        }
        this.options = options;
        if (this.api) {
          this.choseApi(this.module, this.api);
          this.loadResponse(this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][this.module][this.api]);
        }
        return this.$notify({
          type: 'success',
          message: res.msg,
        });
      }).finally(() => {
        toast.clear();
      });
    }
    ,
    moduleSearch(m, mk) {
      if (mk.indexOf(this.searchApiString) > -1) {
        return true;
      }
      for (const mKey in m) {
        let d = m[mKey];
        if (d.summary.indexOf(this.searchApiString) > -1 || d.SystemPath.indexOf(this.searchApiString) > -1 || d.path.indexOf(this.searchApiString) > -1 || d.description.indexOf(this.searchApiString) > -1) {
          return true;
        }
      }
      return false;
    }
    ,
    searchEmpty() {
      if (this.choseApp && this.choseHost && this.choseVersion) {
        if (!this.searchApiString) {
          return false;
        }
        let doc = this.doc[this.choseApp][this.choseHost].doc[this.choseVersion];
        let nullDoc = true;
        for (const docKey in doc) {
          for (const docKeyKey in doc[docKey]) {
            let d = doc[docKey][docKeyKey];
            if (d.summary.indexOf(this.searchApiString) > -1 || d.SystemPath.indexOf(this.searchApiString) > -1 || d.path.indexOf(this.searchApiString) > -1 || d.description.indexOf(this.searchApiString) > -1) {
              for (let i = 0; i < this.titleArr.length; i++) {
                if (this.titleArr[i].indexOf(this.searchApiString) >= 0) {
                  this.retrieval()
                  this.$set(this.isOpenItem, this.titleArr[i], false);
                }
              }
              nullDoc = false;
            }
          }
        }
        return nullDoc;
      } else {
        return false;
      }

    }
    ,
    loadDoc() {
      this.$http.getJSON('__apis.json', {token: this.$store.state.password}).then(res => {
        let options = [];
        this.doc = res.data;
        for (let key in this.doc) {
          let hosts = [];
          for (let host in this.doc[key]) {
            let versions = [];
            for (let version in this.doc[key][host].doc) {
              versions.push({
                text: '版本-' + version,
                value: version,
              });
            }
            hosts.push({
              text: this.doc[key][host].host + ' - ' + this.doc[key][host].mode,
              value: host,
              children: versions,
            });
          }
          let app = {
            text: key,
            value: key,
            children: hosts,
          };
          options.push(app);
        }
        this.options = options;
        if (this.choseVersion) {
          if (window.localStorage.getItem('module')) {
            let storage = window.localStorage.getItem('module').split(',')
            let module = {
              selectedOptions: [
                {
                  value: storage[0]
                },
                {
                  value: storage[1]
                },
                {
                  value: storage[2]
                }
              ]
            }
            this.choseFinish(module)
          } else {
            if (this.api) {
              this.choseApi(this.module, this.api);
            }
          }
        } else {
          if (this.choseApp) {
            this.selectedOptions = [this.choseApp];
            this.cascaderValue = this.choseApp;
          }
          if (this.choseHost) {
            this.selectedOptions.push(this.choseHost);
            this.cascaderValue = this.choseHost;
          }
          this.show = true;
        }

        if (this.api != null) {
          this.loadResponse(this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][this.module][this.api]);
        }
        for (let i in this.doc[this.choseApp][this.choseHost].doc[this.choseVersion]) {
          this.titleArr.push(i)
        }
        for (let i in this.doc[this.choseApp][this.choseHost].doc[this.choseVersion]) {
          this.$set(this.isOpenItem, i, false);
        }
      });
    }
    ,
    allClose() {
      for (let i in this.isOpenItem) {
        if (this.isClose) {
          this.$set(this.isOpenItem, i, true);
        } else {
          this.$set(this.isOpenItem, i, false);
        }
      }
      this.isClose = !this.isClose
    }
    ,
    retrieval() {
      for (let i = 0; i < this.titleArr.length; i++) {
        if (this.titleArr[i].indexOf(this.searchApiString) >= 0) {
          return false
        }
      }
      return true
    }
    ,
  },
  watch: {
    $route() {
      this.choseApp = this.$route.query.app || null;
      this.choseHost = this.$route.query.host || null;
      this.choseVersion = this.$route.query.version || null;
      this.module = this.$route.query.m || null;
      let api = this.$route.query.api || null;
      if (api !== null) {
        this.api = parseInt(api);
      }

      if (!this.choseVersion) {
        this.show = true;
      }
      if (this.api !== null) {
        this.loadResponse(this.doc[this.choseApp][this.choseHost].doc[this.choseVersion][this.module][this.api]);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.docBody {
  background: #f5f5f5;

  display: flex;
  height: 100vh;
  overflow: hidden;
  flex-direction: row;
  overflow-x: auto;

  .popup-lists {
    padding: 30px;

    .module {
      //margin-top: 10px;
      padding-top: 10px;

      .name {
        padding: 8px 0 8px 20px;
        color: #455a64;
        font-weight: 600;
        font-size: 15px;
        line-height: 28px;
        cursor: pointer;
      }

      li {
        display: inline-block;
        margin: 0;
        padding: 8px 0 8px 20px;
        color: #455a64;
        font-size: 14px;
        line-height: 28px;
        -webkit-transition: color 0.2s;
        transition: color 0.2s;
        cursor: pointer;

        &.curr {
          color: #07c160;
        }

        &:hover {
          //color: #fff;
          color: #07c160;
        }
      }
    }
  }

  .slide {
    width: 260px;
    background: #fff;
    box-shadow: 6px 6px 6px #eee;
    //margin-right: 20px;
    display: flex;
    flex-direction: column;

    .keywords {
      border-bottom: 1px solid #eee;
    }

    .api-lists {
      flex: 1;
      overflow: auto;
      transition: all 0.5s;

      .content {
        padding-top: 10px;

        .module {
          //margin-top: 10px;
          padding-top: 10px;

          .name {
            padding: 8px 0 8px 20px;
            color: #455a64;
            font-weight: 600;
            font-size: 15px;
            line-height: 28px;
          }

          li {
            display: block;
            margin: 0;
            padding: 8px 0 8px 20px;
            color: #455a64;
            font-size: 14px;
            line-height: 28px;
            -webkit-transition: color 0.2s;
            transition: color 0.2s;
            cursor: pointer;

            &.curr {
              color: #07c160;
            }

            &:hover {
              //color: #fff;
              color: #07c160;
            }
          }
        }
      }
    }

    .top {
      background: #07c160;
      color: #fff;
      text-align: center;
      padding: 30px 0;
      font-size: 20px;
    }

    .appSelect {
      padding: 10px 10px;
      border-top: 1px solid #eee;

      select {
        appearance: none;
        color: #444;
        width: 100%;
        font-size: 16px;
        border: 1px solid #eee;
        padding: 10px 20px;
        box-sizing: border-box;
        border-radius: 5px;
        position: relative;

        &:after {
          display: block;
          position: absolute;
          content: "〓";
          width: 30px;
          height: 30px;
          color: #444;
          right: 10px;
        }
      }
    }
  }


  .body {
    flex: 1;
    display: flex;
    flex-direction: column;
    //padding-left: 20px;
    //padding-top: 20px;
    //padding-bottom: 20px;
    border-radius: 5px;
    margin-top: -16px;
    height: calc(100vh - 65px);

    .box {
      ::selection {
        color: #fff;
        background: #07c160;
      }

      width: 100%;
      background: #fff;
      box-shadow: 6px 6px 6px #eee;
      padding: 10px 10px 10px 10px;

      box-sizing: border-box;
      //border-radius: 3px;
      .title {
        //margin-bottom: 16px;
        font-weight: 600;
        font-size: 18px;
        //margin-top: 30px;
        &.margin {
          margin-bottom: 16px;
          margin-top: 20px;
        }
      }

      .apiTable {
        width: 100%;
        //max-width: 1200px;
        box-sizing: border-box;
        border: 1px solid #eee;
        //border-radius: 5px;
        //overflow: hidden;
        border-collapse: collapse;

        thead {
          background: #07c160;
          color: #fff;

          tr {
            border-bottom: 1px solid #eee;
          }

          td {
            padding: 8px 10px;
            border-right: 1px solid #eee;
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid #eee;

            &:hover {
              background: #f1f1f1;
            }
          }

          td {
            padding: 8px 10px;
            border-right: 1px solid #eee;

            textarea {
              border: 1px solid #eee;
              width: 100%;
              //min-height: 30px;
              //height: auto;
              resize: vertical;
              overflow: hidden;
              //line-height: 30px;
              padding: 7px 10px;
              box-sizing: border-box;
              border-radius: 3px;
            }

            .file {
              border: 1px solid #eee;
              height: auto;
              min-height: 30px;
              width: 100%;
              border-radius: 3px;
              padding: 10px 10px;
              box-sizing: border-box;

              &:hover {
                background: #fff;
              }
            }

            textarea, .file {
              transition: 0.3s all;

              &.danger {
                border: 1px solid #ff0000;
                color: #ff0000;
              }
            }
          }
        }
      }

      .refreshApi {
        cursor: pointer;

      }

      .description {
        color: #34495e;
        font-size: 15px;
        line-height: 26px;
      }
    }
  }
}

.qname {
  cursor: pointer;
  //background: #f9f9f9;
  display: flex;
  border-bottom: 1px solid #eee;
  align-content: center;
  justify-content: space-between;
}

.slide {
  .module-lists {
    border-bottom: 1px solid #eee;
    transition: all .5s;

    li {
      background: #f7f7f7;
      border-bottom: 1px dashed #eee;
      transition: all 0.5s !important;
      //display: flex !important;
      //flex-direction: row;


      &:hover, &.curr {
        background: #fff;
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }
}

.d-name {
  flex: 1;
  font-size: 15px;
  padding-right: 10px;
}

.d-desc {
  color: #666;
  font-size: 10px;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  padding-right: 10px;
}

.d-msg {
  padding: 0px 10px 0 0;
  display: flex !important;
  flex-direction: row;

  .d-type {

  }

  .url {
    flex: 1;
  }
}

/* 整个滚动条 */
::-webkit-scrollbar {
  width: 10px;
  height: 0px;
  //background-color:#000;
  cursor: pointer;
  box-sizing: border-box;
  padding: 30px 0;
}

/* 滚动条上的滚动滑块. */
::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 50px;
  cursor: pointer;
  //top: 0;
}

/*  滚动条轨道. */
::-webkit-scrollbar-track {

  background-color: #000;
  padding-top: 30px;
}

/* 滚动条没有滑块的轨道部分 */
::-webkit-scrollbar-track-piece {
  background-color: #f7f7f7;
}
</style>
